import axios from 'axios';

const signin = (options, obj) => {
  let bodyFormData = new FormData();

  bodyFormData.append('username', obj.username);
  bodyFormData.append('password', obj.password);

  return axios.post('/accounts/login/', bodyFormData).then(response => {
    if (response.data.active) {
      options.commit('SET_USER', response.data);
    }
    obj.success(response.data);
  }).catch(() => {
    obj.error();
  });
};

const logout = (options, obj) => {
  let bodyFormData = new FormData();
  return axios.post('/accounts/logout/', bodyFormData).then(response => {
    window.location.reload();
    options.commit('SET_USER', response.data);
    obj.success(response);
  }).catch(() => {
    window.location.reload();
    obj.error();
  });
};

const checkUser = (options, obj) => {
  return axios.post('/accounts/whoami/').then(response => {
    options.commit('SET_USER', response.data);

    obj.callback();
  });
};

const reset = (options, obj) => {
  let bodyFormData = new FormData();
  bodyFormData.append('email', obj.email);
  return axios.post('/accounts/reset/', bodyFormData).then(response => {
    obj.success(response);
  }).catch(() => {
    obj.error();
  });
};

const changePassword = (options, obj) => {
  let bodyFormData = new FormData();
  bodyFormData.append('password', obj.password);
  bodyFormData.append('token', obj.token);
  return axios.post('/accounts/reset/token/', bodyFormData).then(response => {
    obj.success(response);
  }).catch(() => {
    obj.error();
  });
};

export default { signin, reset, checkUser, changePassword, logout };
